import MessageSendComponent from "../components/smart/MessageSendComponent";

function MessageSendPage() {
    return (
        <div>
            <MessageSendComponent />
        </div>
    )
}

export default MessageSendPage;